import { useMemo } from 'react';

import { User } from '../types';
import { useCampaignCreators } from './useCampaignCreators';
import { useCampaignModifiers } from './useCampaignModifiers';

export const useCampaignUsers = () => {
  const { campaignCreators } = useCampaignCreators();
  const { campaignModifiers } = useCampaignModifiers();

  const userInfoLookup = useMemo(() => {
    const userInfo = campaignCreators.concat(campaignModifiers);

    return userInfo.reduce(
      (userMapping: { [key: string]: User }, user: User) => ({
        ...userMapping,
        [user.id]: user,
      }),
      {},
    );
  }, [campaignCreators, campaignModifiers]);

  return {
    campaignCreators,
    campaignModifiers,
    userInfoLookup,
  };
};
